import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormControl, Validators, FormsModule } from '@angular/forms';
import { BasketService } from '@core/services/basket/basket.service';
import { GiftcardBalance } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { GiftCardDetails } from '@models/api-orders.models';
import { TranslateSafePipe } from '../../../@shared/translate-safe/translate-safe.pipe';
import { SafePipe } from '@shared/safe/safe.pipe';
import { InputComponent } from '../../../@shared/form-elements/input/input/input.component';
import { SpotHeadlineComponent } from '../spot-headline/spot-headline.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { LoadingDotsComponent } from '../../../@shared/loading-dots/loading-dots.component';

@Component({
    selector: 'app-giftcard-balance',
    templateUrl: './giftcard-balance.component.html',
    styleUrls: ['./giftcard-balance.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LoadingDotsComponent, NgIf, SpotHeadlineComponent, FormsModule, InputComponent, AsyncPipe, SafePipe, TranslateSafePipe]
})
export class GiftcardBalanceComponent {
    public static readonly ref: string = 'giftcardBalance';

    private readonly pendingBs = new BehaviorSubject(false);
    public readonly balance = new UntypedFormControl('', Validators.required);
    public readonly balanceResponseRs = new BehaviorSubject<GiftCardDetails | 'error' | null>(null);
    public readonly balanceResponse$ = this.balanceResponseRs.asObservable();
    public readonly pending$ = this.pendingBs.asObservable();

    @Input()
    public data: GiftcardBalance;

    constructor(private basketService: BasketService) {}

    public onSubmit(control: UntypedFormControl): void {
        if (!control.valid) {
            return;
        }

        this.pendingBs.next(true);

        this.basketService
            .checkGiftCardCode(control.value)
            .pipe(finalize(() => this.pendingBs.next(false)))
            .subscribe({
                next: response => this.balanceResponseRs.next(response),
                error: _ => this.balanceResponseRs.next('error')
            });
    }
}
